import { smb_fetch, getAgpApiUrl, getAgsApiUrl } from '@/api/operator/fetch';
import { isOa } from '@/utils';

/**
 * 获取操作日志列表
 * @return
 */
export const getOperationLogList = (data) => {
  // 在 oa域走销售接口
  if (isOa()) {
    const url = getAgsApiUrl('operation_log', 'get_list');
    return smb_fetch(url, {
      method: 'POST',
      data: { ...data.data },
      contentType: 'application/json',
    }, false)
      .then((res) => {
        const {
          conf,
          list,
        } = res;
        return {
          code: 0,
          data: { list, conf },
        };
      });
  }

  // 否则走运营接口
  const url = getAgpApiUrl('operation_log', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取销售组织架构树
 * @return
 */
export const getSaleOrganizationTree = (data, isCache = false) => {
  const url = getAgsApiUrl('organization', 'tree');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache,
    },
    data,
  );

  return smb_fetch(url, params, false);
};

/**
 * 获取销售员工列表
 * @return
 */
export const getSaleEmployeeList = (data, isCache = false) => {
  const url = getAgsApiUrl('employee', '');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache,
    },
    data,
  );

  return smb_fetch(url, params, false);
};
